module.exports = __webpack_public_path__ + "static/media/FBicon.3f962d1a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/socialIcons/FBicon.png
// module id = 576
// module chunks = 0